import { SubmitHandler, useForm } from 'react-hook-form';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { login } from 'store/actions/auth.action';
import { isUserLoggedIn, storeToken } from 'utils/handler';
import FormPageLayout from 'views/registrar-integrations/FormPageLayout';

interface AffiliateLoginInput {
  email: string;
  password: string;
}

export const AffiliateLoginPage: React.FC = (): JSX.Element => {
  const history = useHistory();
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors, isSubmitting },
  } = useForm<AffiliateLoginInput>({ mode: 'onSubmit' });

  const onSubmit: SubmitHandler<AffiliateLoginInput> = async (data) => {
    const token = await login({ ...data });
    if (!token) return;
    await storeToken(token);
    history.push('/dashboard');
  };

  const forgotPassword = () => {
    history.push('/forgot-password', { email: getValues('email'), returnURL: '/dashboard' });
  };

  if (isUserLoggedIn()) return <Redirect to="/dashboard" />;

  return (
    <FormPageLayout
      title="Affiliate Login | Saw.com"
      heading="Affiliate login"
      subtitle="Log in to see your Affiliate ID, setup steps and statistics."
    >
      <div className="rewamp-form">
        <form className="form" onSubmit={handleSubmit(onSubmit)} noValidate>
          <div className="form-group">
            <input type="email" autoComplete="email" placeholder="Email Address*" {...register('email', {
              setValueAs: (value: string) => value.trim(),
              required: 'Email is required',
              pattern: { value: /\S+@\S+\.\S+/, message: 'Invalid email' },
            })} />
            {errors.email && <span className="field-error">{errors.email.message}</span>}
          </div>

          <div className="form-group">
            <input type="password" autoComplete="current-password" placeholder="Password*" {...register('password', {
              required: 'Password is required',
            })} />
            {errors.password && <span className="field-error">{errors.password.message}</span>}
          </div>

          <button type="submit" disabled={isSubmitting}>{isSubmitting ? 'Logging in...' : 'Log in'}</button>
        </form>
        <p className="form-page-switch">
          <button type="button" className="form-page-link" onClick={forgotPassword}>Forgot password?</button>
          {' · '}
          New affiliate? <Link to="/affiliates">Sign up</Link>
        </p>
      </div>
    </FormPageLayout>
  );
};

export default AffiliateLoginPage;
